<footer class="footer-container">
    <div class="email-section">
        <span>ITSupport@kingsettcapital.com</span>
    </div>
    <div class="company-section">
        <div class="company-info">
            <div class="company-title">                
                <!-- <mat-icon>copyright</mat-icon> -->
                <span>© 2026 KingSett Capital</span>
            </div>
            <span>|</span>
            <div class="link-section">
                <!-- <a [routerLink]="'/privacy-policy'">Privacy Policy</a> -->
                <a href="https://www.kingsettcapital.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                <a [routerLink]="'/cookie-policy'">Cookie policy</a>
            </div>
        </div>
    </div>
</footer>